var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13,
    height: 13.5469,
    viewBox: "0 0 13 13.5469",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-flag 1",
    filter: "url(#filter0_d_0_21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M2.94534 11.0391V2.50781C2.94534 2.22736 3.17269 2 3.45315 2H9.5469C9.74209 2 9.91996 2.11191 10.0045 2.28783C10.0891 2.46376 10.0654 2.67257 9.94343 2.825L8.57214 4.53906L9.94343 6.25313C10.0654 6.40556 10.0891 6.61437 10.0045 6.7903C9.91996 6.96622 9.74209 7.07812 9.5469 7.07812H3.96096V11.0391C3.96096 11.3195 3.73361 11.5469 3.45315 11.5469C3.17269 11.5469 2.94534 11.3195 2.94534 11.0391Z",
    fill: "url(#paint0_linear_0_21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke) (Stroke)",
    d: "M2.94534 11.0391C2.94534 11.3195 3.17269 11.5469 3.45315 11.5469C3.73361 11.5469 3.96096 11.3195 3.96096 11.0391V7.07812H9.5469C9.71763 7.07812 9.87539 6.9927 9.96877 6.85352L10.0049 6.79004C10.0893 6.61418 10.0652 6.40525 9.94338 6.25293L8.57229 4.53906L9.94338 2.8252C10.0652 2.67287 10.0893 2.46394 10.0049 2.28809C9.92034 2.11216 9.74209 2 9.5469 2V1C10.0904 1 10.5885 1.29209 10.8555 1.75879L10.9063 1.85449L10.9492 1.9541C11.1467 2.45392 11.0638 3.02495 10.7246 3.44922L9.85256 4.53906L10.7246 5.62891C11.0865 6.08158 11.1572 6.70158 10.9063 7.22363C10.6553 7.7458 10.1267 8.07812 9.5469 8.07812H4.96096V11.0391C4.96096 11.8718 4.28589 12.5469 3.45315 12.5469C2.62041 12.5469 1.94534 11.8718 1.94534 11.0391V2.50781C1.94534 1.67507 2.62041 1 3.45315 1V2C3.17269 2 2.94534 2.22736 2.94534 2.50781V11.0391ZM9.5469 1V2H3.45315V1H9.5469Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_21",
    x: -1,
    y: -0.726562,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_21",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_21",
    x1: 3.19888,
    y1: 5.59407,
    x2: 9.85189,
    y2: 5.59316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBadge);
export default __webpack_public_path__ + "static/media/flag-badge.12923e6b265961d9070948a9b8c83096.svg";
export { ForwardRef as ReactComponent };